export const numberOfProjectsTotalCalculation = (props: any) => {
    const {projectsBreakdown} = props;

    if (!projectsBreakdown) return 0;

    return projectsBreakdown.levels.filter((level: any) => level.parent_id).length;
}